import { render, staticRenderFns } from "./captain.vue?vue&type=template&id=5470b3d3&"
import script from "./captain.vue?vue&type=script&lang=js&"
export * from "./captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5470b3d3')) {
      api.createRecord('5470b3d3', component.options)
    } else {
      api.reload('5470b3d3', component.options)
    }
    module.hot.accept("./captain.vue?vue&type=template&id=5470b3d3&", function () {
      api.rerender('5470b3d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/tabs/captain.vue"
export default component.exports